import { staticContentRoutes } from 'thewest/routes/static/static-content-routes'
import { customTopicRoutes } from 'thewest/routes/topic/custom-topic-routes'
import { userOverridesRoute } from 'thewest/routes/custom/experimental-features'
import { liveScoresRoute } from 'thewest/routes/custom/get-live-scores-route-info'

import { homepage } from 'thewest/routes/home'
import { layout } from 'thewest/App.routing'
import { myHome } from './my-home'
import { StaticRoutes } from 'common/routing/page-definition'
import { regionalRoutes } from './regionals'
import { TheWestSection } from 'component-library/__styling/settings/sections/thewest'
import { westlive } from './west-live'

export const staticRoutes: StaticRoutes<typeof layout, TheWestSection> = {
    ...staticContentRoutes,
    ...customTopicRoutes,
    ...homepage,
    ...userOverridesRoute,
    ...liveScoresRoute,
    ...myHome,
    ...regionalRoutes,
    ...westlive,
}
